import { format } from "date-fns";

import type { CervicalExamFlowsheetFormValues } from "@/encounters/components/EncounterLabor/flowsheet-forms/cervical-exam/types/cervical-exam-form";
import type { CervicalExamFlowsheetFormSchemaType } from "@/encounters/components/EncounterLabor/flowsheet-forms/cervical-exam/zod-schemas/cervical-exam-flowsheet-form";
import { localToUtcTimeString } from "@/utils/timeUtils";

/** Empty form values with null datetime. Used when hydrating from a QuestionnaireResponse. */
export function getEmptyCervicalExamFlowsheetFormValues(): CervicalExamFlowsheetFormValues {
  return {
    examDate: null,
    examTime: null,
    dilation: "",
    effacement: "",
    station: "",
    consistency: null,
    locationOfCervix: null,
    fetalPresentation: null,
    activeLabor: null,
    notes: "",
    signatureInitials: [],
  };
}

/** Defaults for a new quick-add form, with the current local date and time filled in. */
export function getDefaultCervicalExamFlowsheetFormValues(): CervicalExamFlowsheetFormValues {
  const now = new Date();
  const localTime = format(now, "HH:mm:ss");
  return {
    ...getEmptyCervicalExamFlowsheetFormValues(),
    examDate: now,
    examTime: localToUtcTimeString(localTime),
  };
}

export function normalizeCervicalExamFlowsheetFormValues(
  parsed: CervicalExamFlowsheetFormSchemaType,
): CervicalExamFlowsheetFormValues {
  // Keep explicit null date/time from the form. Current date/time only comes from
  // getDefaultCervicalExamFlowsheetFormValues for new quick-add entries.
  const empty = getEmptyCervicalExamFlowsheetFormValues();
  return {
    examDate: parsed.examDate !== undefined ? parsed.examDate : empty.examDate,
    examTime: parsed.examTime !== undefined ? parsed.examTime : empty.examTime,
    dilation: parsed.dilation ?? empty.dilation,
    effacement: parsed.effacement ?? empty.effacement,
    station: parsed.station ?? empty.station,
    consistency: parsed.consistency ?? empty.consistency,
    locationOfCervix: parsed.locationOfCervix ?? empty.locationOfCervix,
    fetalPresentation: parsed.fetalPresentation ?? empty.fetalPresentation,
    activeLabor: parsed.activeLabor ?? empty.activeLabor,
    notes: parsed.notes ?? empty.notes,
    signatureInitials: parsed.signatureInitials ?? empty.signatureInitials,
  };
}
